import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import ReceiptPage from './components/ReceiptPage';
import Cookies from 'js-cookie';
import './App.css';

function App() {
  const accountInfo = Cookies.getJSON('accountInfo');

  useEffect(() => {
    if (accountInfo) {
      console.log('Account Info:', accountInfo);
    }
  }, [accountInfo]);

  return (
    <Router>
      <div className="App">
        <header className="App-header">
          {accountInfo ? <p>Welcome, {accountInfo.name}</p> : <p>Please log in</p>}
        </header>
        <Switch>
          <Route exact path="/">
            {accountInfo ? <Redirect to="/receipt" /> : <LoginPage />}
          </Route>
          <Route path="/receipt" component={ReceiptPage} />
        </Switch>
      </div>
    </Router>
  );
}

export default App;
